import { Box } from '@common-components';
import { PartialSubmission, SubmissionMarket } from 'types';
import ComposeEmailButtons, { EmailToMarketButton } from './ComposeEmailButtons';

interface EmailsListFooterProps {
  submissionMarket?: SubmissionMarket;
  submission: PartialSubmission | null;
}

export default function EmailsListComposeButton({ submissionMarket, submission }: EmailsListFooterProps) {
  return (
    <Box>
      {!submissionMarket && <ComposeEmailButtons submission={submission} />}
      {submissionMarket && <EmailToMarketButton submissionMarket={submissionMarket} />}
    </Box>
  );
}
